import fitvids from "fitvids";
import helpers from "../utils/helpers";

function hasPreferencesConsent() {
  return (
    window._solepharmPreferencesConsent ||
    (window.silktideConsentManager &&
      typeof window.silktideConsentManager.getConsentChoice === "function" &&
      window.silktideConsentManager.getConsentChoice("preferences"))
  );
}

const YTVideo = {
  videos: {},

  init() {
    // YT iframe API is loaded by Silktide when user accepts Preferences (scripts config)
    // Define videoYTRender for onYouTubeIframeAPIReady in base.php (must exist before API loads)
    window.videoYTRender = function () {
      $(".yt-video").each(function () {
        const wraperEl = $(this);
        const videoEl = wraperEl.find(".yt-video__video");

        const videoId = videoEl.data("id");

        new YT.Player(videoEl[0], {
          videoId: videoId, // YouTube Video ID
          width: 560,
          height: 316,
          playerVars: {
            autoplay: 1,
            cc_load_policy: 0,
            controls: 1,
            fs: 1,
            iv_load_policy: 3,
            modestbranding: 1,
            origin: location.origin,
            playsinline: 1,
            rel: 0,
            start: 0,
          },
          events: {
            onReady: function (e) {
              const player = e.target;

              player.mute().loadModule();

              YTVideo.videos[videoId] = player;

              wraperEl.find(".yt-video__poster").on("click", function () {
                player.seekTo(0).playVideo();
                wraperEl.addClass("playing");
              });
            },
          },
        });
      });
    };

    if ($(".yt-video").length) {
      // Early poster click: block and show message if user has not granted Preferences consent
      $(".yt-video__poster").on("click", function (e) {
      if (!hasPreferencesConsent()) {
        e.preventDefault();
        e.stopPropagation();
        const wrapper = $(this).closest(".yt-video");
        if (wrapper.find(".yt-video__consent-message").length) {
          return false;
        }
        const msg =
          (typeof translations !== "undefined" &&
            translations.youtube_consent_required) ||
          "Please enable Preferences cookies to watch this video.";
        const overlay = $(
          '<div class="yt-video__consent-message"><span>' +
            msg +
            "</span></div>"
        );
        wrapper.append(overlay);
        overlay.on("click", function () {
          overlay.remove();
        });
        return false;
      }
    });

    $(window).on("scroll", function () {
      $(".yt-video.autoplay").each(function () {
        const wraperEl = $(this);
        const videoEl = wraperEl.find(".yt-video__video");
        const videoID = videoEl.data("id");
        const player = YTVideo.videos[videoID];

        if (!player) {
          return;
        }

        // Check if video is in viewport
        if (helpers.isInViewport(videoEl[0])) {
          // Play video
          player.seekTo(0).playVideo();
          wraperEl.addClass("playing");
        }
      });
    });
    }

    this.initOembedPlaceholders();
  },

  initOembedPlaceholders() {
    const placeholders = document.querySelectorAll(".yt-embed-placeholder");
    if (!placeholders.length) return;

    placeholders.forEach((placeholder) => {
      const trigger = placeholder.querySelector(".yt-embed-placeholder__trigger");
      const target = trigger || placeholder;

      target.addEventListener("click", (e) => {
        e.preventDefault();

        if (!hasPreferencesConsent()) {
          if (placeholder.querySelector(".yt-embed-placeholder__consent-message"))
            return;
          const msg =
            (typeof translations !== "undefined" &&
              translations.youtube_consent_required) ||
            "Please enable Preferences cookies to watch this video.";
          const overlay = document.createElement("div");
          overlay.className = "yt-embed-placeholder__consent-message";
          overlay.innerHTML = "<span>" + msg + "</span>";
          overlay.addEventListener("click", () => overlay.remove());
          placeholder.appendChild(overlay);
          return;
        }

        const src = placeholder.getAttribute("data-src");
        if (!src) return;

        const iframe = document.createElement("iframe");
        iframe.src = src;
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "");

        const wrapper = placeholder.closest(".yt-embed-placeholder-wrapper");
        placeholder.replaceWith(iframe);

        fitvids(wrapper || iframe.parentElement);
      });
    });
  },
};

export default YTVideo;
